<template>
  <aside id="sidebar" class="app-sidebar fixed inset-y-0 left-0 z-40 flex w-72 flex-col" :class="{ 'is-open': open }">
    <div class="sidebar-brand flex h-24 items-center border-b border-stone-200 px-6">
      <router-link to="/home" aria-label="Sistema Financeiro GarantePay" @click="$emit('close')">
        <img class="brand-logo" :src="logo" alt="GarantePay">
      </router-link>
      <button class="sidebar-close-button" type="button" aria-label="Fechar menu" @click="$emit('close')">
        <AppIcon name="close" />
      </button>
    </div>

    <nav class="flex-1 overflow-y-auto px-4 py-6" aria-label="Menu principal">
      <div class="mb-3 px-3 text-[11px] font-extrabold uppercase tracking-[.18em] text-stone-400">Gestão financeira</div>
      <router-link to="/home" class="navitem" @click="$emit('close')"><AppIcon name="dashboard" />Painel executivo</router-link>
      <router-link v-if="hasAccess('OBLIGATIONS')" to="/obrigacoes" class="navitem" @click="$emit('close')"><AppIcon name="file" />Obrigações</router-link>
      <router-link v-if="hasAccess('INSTALLMENT_AGENDA')" to="/agenda-parcelas" class="navitem" @click="$emit('close')"><AppIcon name="calendar" />Agenda de parcelas</router-link>
      <router-link v-if="hasAccess('PAYMENTS')" to="/pagamentos" class="navitem" @click="$emit('close')"><AppIcon name="money" />Pagamentos</router-link>
      <router-link v-if="hasAccess('PAYMENT_ALLOCATIONS')" to="/baixas-rateios" class="navitem" @click="$emit('close')"><AppIcon name="transactions" />Baixas e rateios</router-link>
      <router-link v-if="hasAccess('CHARGES')" to="/cobrancas" class="navitem" @click="$emit('close')"><AppIcon name="receipt" />Cobranças</router-link>
      <router-link v-if="hasAccess('PAYMENT_ORDERS')" to="/programacoes-pagamento" class="navitem" @click="$emit('close')"><AppIcon name="calendar" />Programações</router-link>
      <router-link v-if="hasAccess('PAYMENT_APPROVALS')" to="/aprovacoes-pagamento" class="navitem" @click="$emit('close')"><AppIcon name="check" />Aprovações</router-link>
      <router-link v-if="hasAccess('RECURRENCES')" to="/recorrencias" class="navitem" @click="$emit('close')"><AppIcon name="refresh" />Recorrências</router-link>
      <router-link v-if="hasAccess('RECONCILIATION')" to="/conciliacao" class="navitem" @click="$emit('close')"><AppIcon name="check" />Conciliação</router-link>
      <router-link v-if="hasAccess('BANK_AUTOMATION')" to="/automacao-bancaria" class="navitem" @click="$emit('close')"><AppIcon name="bank" />Automação bancária</router-link>
      <router-link v-if="hasAccess('PROVIDER_CONFIGURATION')" to="/automacao-bancaria/provedores" class="navitem" @click="$emit('close')"><AppIcon name="settings" />Provedores de pagamento</router-link>
      <router-link v-if="hasAccess('PAYMENT_ADJUSTMENTS')" to="/estornos-reembolsos" class="navitem" @click="$emit('close')"><AppIcon name="refresh" />Estornos e reembolsos</router-link>
      <router-link v-if="hasAccess('ADVANCED_REPORTS')" to="/relatorios-gerenciais" class="navitem" @click="$emit('close')"><AppIcon name="chart" />Relatórios gerenciais</router-link>
      <router-link v-if="hasAccess('MESSAGE_OPERATIONS')" to="/mensageria" class="navitem" @click="$emit('close')"><AppIcon name="transactions" />Mensageria</router-link>

      <div class="mb-3 mt-7 px-3 text-[11px] font-extrabold uppercase tracking-[.18em] text-stone-400">Ledger</div>
      <router-link v-if="hasAccess('LEDGER')" to="/ledger" class="navitem" @click="$emit('close')"><AppIcon name="book" />Transações e saldos</router-link>
      <router-link v-if="hasAccess('LEDGER_CONFIGURATION')" to="/ledger/configuracoes" class="navitem" @click="$emit('close')"><AppIcon name="settings" />Configurações</router-link>

      <!--
        <div class="mb-3 px-3 text-[11px] font-extrabold uppercase tracking-[.18em] text-stone-400">Gestão financeira</div>
      <router-link to="/home" class="navitem" @click="$emit('close')"><AppIcon name="dashboard" />Painel executivo</router-link>
      <button v-for="item in operationItems" :key="item.label" class="navitem navitem-button" type="button" title="Disponível em uma próxima etapa">
        <AppIcon :name="item.icon" />{{ item.label }}
      </button>
      -->

      <div class="mb-3 mt-3 px-3 text-[11px] font-extrabold uppercase tracking-[.18em] text-stone-400">Cadastros</div>
      <router-link v-if="hasAccess('FINANCIAL_ENTITY_TYPES')" to="/cadastros/tipos-entidade-financeira" class="navitem" @click="$emit('close')"><AppIcon name="tags" />Tipos de entidade</router-link>
      <template v-for="item in cadastroItems" :key="item.label">
        <router-link v-if="item.to && hasAccess(item.moduleCode)" :to="item.to" class="navitem" @click="$emit('close')"><AppIcon :name="item.icon" />{{ item.label }}</router-link>
        <button v-else class="navitem navitem-button" type="button" title="Disponível em uma próxima etapa"><AppIcon :name="item.icon" />{{ item.label }}</button>
      </template>

      <!--
      <div class="mb-3 mt-7 px-3 text-[11px] font-extrabold uppercase tracking-[.18em] text-stone-400">Ledger</div>
      <button v-for="item in ledgerItems" :key="item" class="navitem navitem-button" type="button" title="Disponível em uma próxima etapa">
        <AppIcon name="book" />{{ item }}
      </button>
      -->
    </nav>

    <div class="sidebar-environment m-4 rounded-2xl bg-[#102a5a] p-4 text-white">
      <div class="text-xs text-blue-200">Ambiente autenticado</div>
      <div class="mt-1 text-sm font-bold">GarantePay Financeiro</div>
      <!-- <div class="mt-3 h-1.5 overflow-hidden rounded-full bg-white/15"><div class="h-full w-4/5 rounded-full bg-[#e77900]" /></div>
      <div class="mt-2 text-[11px] text-blue-200">Estrutura inicial configurada</div> -->
    </div>
  </aside>
</template>

<script>
import logo from '../assets/logogarantepay.jpg'
import AppIcon from './AppIcon.vue'
import financialAccessService from '../services/financialAccessService'

export default {
  name: 'AppSidebar',
  components: { AppIcon },
  props: { open: { type: Boolean, default: false } },
  emits: ['close'],
  data: () => ({
    logo,
    accessModules: [],
    cadastroItems: [
      { label: 'Entidades financeiras', icon: 'building', to: '/cadastros/entidades-financeiras', moduleCode: 'FINANCIAL_ENTITIES' },
      { label: 'Métodos de pagamento', icon: 'card', to: '/cadastros/metodos-pagamento', moduleCode: 'PAYMENT_METHODS' },
      { label: 'Contas bancárias', icon: 'bank', to: '/cadastros/contas-bancarias', moduleCode: 'BANK_ACCOUNTS' },
      { label: 'Tipos de conta', icon: 'wallet', to: '/cadastros/tipos-conta', moduleCode: 'ACCOUNT_TYPES' },
      { label: 'Contas do ledger', icon: 'book', to: '/cadastros/contas-ledger', moduleCode: 'LEDGER_ACCOUNTS' },
      { label: 'Tipos de documento', icon: 'file', to: '/cadastros/tipos-documento', moduleCode: 'DOCUMENT_TYPES' },
      { label: 'Tipos de cobrança', icon: 'receipt', to: '/cadastros/tipos-cobranca', moduleCode: 'CHARGE_TYPES' }
    ],
    operationItems: [
      { label: 'Lançamentos', icon: 'transactions' },
      { label: 'Notas fiscais', icon: 'file' },
      { label: 'Contas bancárias', icon: 'bank' },
      { label: 'Clientes e fornecedores', icon: 'users' },
      { label: 'Relatórios', icon: 'chart' }
    ],
    ledgerItems: ['Grupos de transação', 'Transações', 'Lançamentos contábeis']
  }),
  async created () {
    try { this.accessModules = (await financialAccessService.load()).modules } catch { this.accessModules = [] }
  },
  methods: {
    hasAccess (moduleCode, minimumLevel = 1) { return this.accessModules.some(item => item.moduleCode === moduleCode && item.accessLevel >= minimumLevel) }
  }
}
</script>
